import { ECompareType, EQuestionActionsTypes } from '@cian/frontend-request-form-widget';
import { EFormFieldsNames, EQuestionCodes, EStepCodes } from '../../../types/requestForm';
import { createFields } from './utils/createFields';
import { createValidation } from './utils/createValidation';
import { NEXT_BUTTON_TEXT } from '../../../constants/requestForm/buttonText';
import { ELoginIssueType } from '../../../types/loginIssueType';
var FIELDS = [EFormFieldsNames.LoginIssueType];
export var LOGIN_INITIAL_STEP = {
  code: EStepCodes.Login,
  question: {
    code: EQuestionCodes.Login,
    title: 'Вход на сайт (авторизация, пароль, удаление аккаунта)',
    fields: createFields(FIELDS),
    validation: createValidation(FIELDS),
    actions: [{
      type: EQuestionActionsTypes.NextQ,
      text: NEXT_BUTTON_TEXT
    }]
  },
  nextStep: [{
    conditions: [{
      answerField: EFormFieldsNames.LoginIssueType,
      compareType: ECompareType.Eq,
      value: [ELoginIssueType.ChangedPhone]
    }],
    nextStepCode: EStepCodes.ChangedPhoneInitial
  }, {
    conditions: [{
      answerField: EFormFieldsNames.LoginIssueType,
      compareType: ECompareType.Eq,
      value: [ELoginIssueType.AnotherQuestion]
    }],
    nextStepCode: EStepCodes.CommonForm
  }]
};